import {
	Component,
	OnInit,
	Input,
	Output,
	EventEmitter,
	ChangeDetectorRef,
	ViewChild,
	ElementRef
} from "@angular/core";
import { GlobalService } from "../../../services/global/global.service";
import { Observable } from "rxjs";
import { DMVStoreService } from "../../../services/dmv/dmv-store.service";
import { TagCatalogResponse } from "src/app/models/dmv/tagCatalogResponse";
import { TagCatalog } from "src/app/models/dmv/tagCatalog";
import { Tag } from "src/app/models/dmv/tag";
import { TagImageCodeXref } from "src/app/models/dmv/tagImageCodeXref";
import { AppUtil } from "../../../utils/app.util";

declare var $: any;

@Component({
	selector: "dmv-plate-change",
	templateUrl: "./plate-change.component.html",
	styleUrls: ["./plate-change.component.css"]
})
export class PlateChangeComponent implements OnInit {
	constructor(
		public globalService: GlobalService,
		public dmvStoreService: DMVStoreService
	) {}

	@Input() public registrationNumber: number;
	@Input() public newAltText: string;
	@Input() public plateStyleNetChange: number;
	@Input() public plateStyleProcessingCost: number;
	@Input() public newPlateStyleCost: number;
	@Input() public plateStyleRepLacementFee: number;

	@Input() public newImageCode: string;
	ngOnInit() {
		AppUtil.log("PlateChangeComponent ngOnInit() == >");
	}
}
